import PrivateRoute from 'utils/privateRoute';
import PlatformHealthDashboard from '../components/PlatformHealth/PlatformHealthDashboard';

const PlatformHealthObsRoutes = [
    {
        key: 'power_user_activity_dash',
        route: '/dataOps/platformHealth/summary',
        component: (
            <PrivateRoute
                Component={PlatformHealthDashboard}
                restrictedRoles={['Data Operations Admin', 'Data Operations User', 'D&AI Executive User', 'Program Executive']}
            />
        )
    },
];

export default PlatformHealthObsRoutes;